<template>
  <div
    class="newstopic"
    style="position:relative"
  >
    <el-scrollbar class="comments related_matter">
      <div class="news_topic_material">
        <div
          class="news_topic_material_title"
          :class="[currentMaterialType=='picture'?'news_topic_titleActive':'']"
          @click.stop='getEachTypeMaterialData("picture")'
        >
          <span>图片</span>
          <span v-if="newsTopicObj.pictures">({{newsTopicObj.pictures.length}})</span>
        </div>
        <div
          class="news_topic_material_title"
          :class="[currentMaterialType=='video'?'news_topic_titleActive':'']"
          @click.stop='getEachTypeMaterialData("video")'
        >
          <span>视频</span>
          <span v-if="newsTopicObj.videos">({{newsTopicObj.videos.length}})</span>
        </div>
        <div
          class="news_topic_material_title"
          :class="[currentMaterialType=='audio'?'news_topic_titleActive':'']"
          @click.stop='getEachTypeMaterialData("audio")'
        >
          <span>音频</span>
          <span v-if="newsTopicObj.audios">({{newsTopicObj.audios.length}})</span>
        </div>
        <div
          class="news_topic_material_title"
          :class="[currentMaterialType=='attachment'?'news_topic_titleActive':'']"
          @click.stop='getEachTypeMaterialData("attachment")'
        >
          <span>附件</span>
          <span v-if="newsTopicObj.files">({{newsTopicObj.files.length}})</span>
        </div>
      </div>

      <div class="bottom_content left_info">
        <el-checkbox
          v-if="currentMaterial.length > 0"
          v-model="isCheckedAll"
          @change="changeAllRelateMatter"
        >全选</el-checkbox>
        <span
          class="operate_button"
          v-if="isShowOperateButton && articleMspObj && articleMspObj.ctrl && articleMspObj.ctrl.role && articleMspObj.ctrl.role.edit"
          @click.stop='batchChangeRelateMatter()'
        >批量修改信息</span>
        <span
          class="operate_button"
          v-if="isShowOperateButton && currentMaterialType=='picture' && articleMspObj && articleMspObj.ctrl && articleMspObj.ctrl.role && articleMspObj.ctrl.role.edit"
          @click.stop='batchDownLoadPicture()'
        >打包下载</span>
        <span
          class="operate_button"
          v-if="isShowOperateButton && articleMspObj && articleMspObj.ctrl && articleMspObj.ctrl.role && articleMspObj.ctrl.role.edit"
          @click.stop='deleteMoreRelateMatter()'
        >批量移除</span>
      </div>

      <div
        class="news_topic_material_content"
        style="padding-top:10px;"
      >
        <div
          class="news_topic_material_each"
          style="width:90%; box-sizing:border-box;margin-right:10px;margin-left:30px;"
          v-for='(item,index) in currentMaterial'
        >
          <el-checkbox
            v-model="item.isChoice"
            style="left:-20px;position:absolute;"
          />
          <div class="news_topic_material_each_opacity">
            <span
              @click.stop='previewFile(item)'
              v-if='(item.type === "picture" || item.type === "video" || item.type === "audio")'
            >预览</span>
            <span
              v-if="articleMspObj && articleMspObj.ctrl && articleMspObj.ctrl.role && articleMspObj.ctrl.role.edit"
              @click.stop='changeMatterBaseInfo(item)'
            >
              <span
                style="margin-left:4px;"
                v-if='(item.type === "picture" || item.type === "video" || item.type === "audio")'
              >|</span>
              <span>修改</span>
            </span>
            <span
              style="margin-left:4px;"
              v-if='isCanInsert && (item.type === "picture" || item.type === "video" || item.type === "audio")'
              @click.stop='insertImgToEditor(item)'
            >
              <span>|</span>
              <span>插入</span>
            </span>
            <span
              v-if="articleMspObj && articleMspObj.ctrl && articleMspObj.ctrl.role && articleMspObj.ctrl.role.edit"
              style="margin-left:4px;"
              @click.stop='downLoadData(item)'
            >
              <span>|</span>
              <span>下载</span>
            </span>
            <span
              v-if="articleMspObj && articleMspObj.ctrl && articleMspObj.ctrl.role && articleMspObj.ctrl.role.edit"
              style="margin-left:4px;"
              @click.stop='deleteRelatedMatter(item,index)'
            >
              <span>|</span>
              <span>移除</span>
            </span>
          </div>

          <div class="news_topic_material_img">
            <img
              :src="item.url"
              alt=""
              v-if="item.type=='picture'"
            >
            <img
              src="../../../static/img/newsvideo.png"
              alt=""
              v-if='item.type=="video"'
            >
            <img
              src="../../../static/img/newsaudio.png"
              alt=""
              v-if='item.type=="audio"'
            >
            <img
              src="../../../static/img/newsfujian.png"
              alt=""
              v-if='item.type=="file"'
            >
          </div>
          <div
            class="news_topic_material_name"
            :title="item.title"
            style="width:84%;"
          >
            {{item.title}}
          </div>
        </div>
      </div>
    </el-scrollbar>
    <div
      class="upload_button"
      v-if="articleMspObj && articleMspObj.ctrl && articleMspObj.ctrl.role && articleMspObj.ctrl.role.edit"
    >
      <el-dropdown>
        <el-button
          type="primary"
          style="padding:0px;width:120px;height:36px;"
        >
          <i class="el-icon-arrow-down el-icon-plus"></i>
          本地上传
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="uploadPicture()">上传图片</el-dropdown-item>
          <el-dropdown-item @click.native="uploadMatter('video')">上传视频</el-dropdown-item>
          <el-dropdown-item @click.native="uploadMatter('audio')">上传音频</el-dropdown-item>
          <el-dropdown-item @click.native="uploadMatter('file')">上传附件</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-button
        type="primary"
        style="padding:0px;width:120px;height:36px;margin-left:30px;"
        @click.native="getRelatedMatterFromMatter()"
      >
        素材库选择
      </el-button>

    </div>

  </div>
</template>

<script>
import * as api from '../../../api'
import { download } from '../../../helpers/exportFile'
export default {
  name: 'relatedmatter',
  data () {
    return {
      currentMaterialType: 'picture',
      currentMaterial: [],
      allRelateMatterLength: 0,
      isCheckedAll: false
    }
  },
  props: {
    isCanInsert: {
      type: Boolean,
      required: true
    }
  },
  created () {

  },
  components: {

  },
  computed: {
    newsTopicObj () {
      return this.$store.state.logs.relatedMatters
    },
    articleMspObj () {
      return this.$parent.$parent.articleMspObj
    },
    isShowOperateButton () {
      var k = 0
      for (var i = 0; i < this.currentMaterial.length; i++) {
        if (!this.currentMaterial[i].isChoice) {
          k++
        } else {
          break
        }
      }
      if (k === this.currentMaterial.length) {
        return false
      } else {
        return true
      }
    }
  },
  mounted () {


  },
  destroyed () {

  },
  methods: {
    getEachTypeMaterialData (type) {
      this.currentMaterialType = type
      if (this.newsTopicObj) {
        switch (type) {
          case 'picture':
            this.currentMaterial = this.newsTopicObj.pictures
            break;
          case 'video':
            this.currentMaterial = this.newsTopicObj.videos
            break;
          case 'audio':
            this.currentMaterial = this.newsTopicObj.audios
            break;
          case 'attachment':
            this.currentMaterial = this.newsTopicObj.files
            break;
          default:
            break;
        }
        this.isCheckedAll = false
        for (var j = 0; j < this.currentMaterial.length; j++) {
          this.$set(this.currentMaterial[j], 'isChoice', false)
        }
      }
    },
    changeAllRelateMatter (val) {
      if (val) {
        for (var i = 0; i < this.currentMaterial.length; i++) {
          this.$set(this.currentMaterial[i], 'isChoice', true)
        }
      } else {
        for (var j = 0; j < this.currentMaterial.length; j++) {
          this.$set(this.currentMaterial[j], 'isChoice', false)
        }
      }
    },
    insertImgToEditor (item) {
      this.$parent.$parent.insertContentToEditor(item)
    },
    previewFile (item) {
      if (item.type === 'video') {
        this.$root.eventHub.$emit('getMatterDetail', item, 'videoDetail', this.articleMspObj)
      } else if (item.type === 'audio') {
        this.$root.eventHub.$emit('getMatterDetail', item, 'audioDetail', this.articleMspObj)
      }
      else if (item.type === 'picture') {
        this.$root.eventHub.$emit('getMatterDetail', item, 'imgDetail', this.articleMspObj)
      }
    },
    downLoadData (data) {
      var url = _IMGFILEURL_ + 'downloader/url'
      var option = {
        ...this.$store.getters.baseOption,
        'params': {
          'id': data.id
        }
      }
      if (data.type === 'picture' || data.type === 'file') {
        api._post(url, option).then((res) => {
          if (res.code == 200) {
            download(res.data)
          }
        }).catch((error) => {
          console.log(error)
        })
      } else {
        this.downloadVideo(data.url, data.title)
      }
    },
    downloadVideo (url, filename) {
      var link = document.createElement('a')
      var body = document.querySelector('body')
      link.href = url
      link.download = filename
      link.target = '_blank'
      // fix Firefox
      link.style.display = 'none'
      body.appendChild(link)
      link.click()
      body.removeChild(link)
      window.URL.revokeObjectURL(link.href)
    },

    uploadPicture () {
      this.$root.eventHub.$emit('uploadRelatedpicModel', JSON.parse(JSON.stringify(this.articleMspObj)))
    },
    uploadMatter (type) {
      this.$root.eventHub.$emit('uploadMatterModel', JSON.parse(JSON.stringify(this.articleMspObj)), type)
    },
    getRelatedMatterFromMatter () {
      this.$root.eventHub.$emit('relatedMatterFromMaterial', JSON.parse(JSON.stringify(this.articleMspObj)))
    },
    deleteRelatedMatter (item, index) {
      var url = _IMGFILEURL_ + 'public/delArticle_m'
      var option = {
        ...this.$store.getters.baseOption,
        params: {
          articleId: this.$parent.$parent.articleId,
          materialIds: [item.id]
        }
      }
      this.$confirm('确认删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api._post(url, option).then((res) => {
          if (res.code == 200) {
            this.$notify.success({
              title: '成功',
              message: '删除成功'
            })
            this.currentMaterial.splice(index, 1)
            this.allRelateMatterLength = this.allRelateMatterLength - 1
            if (this.allRelateMatterLength == 0) {
              this.getDeletaAllRelateMatter()
            }
          }
        }).catch((error) => {
          console.log(error)
        })

      }).catch(() => {
        console.log('取消')
      })
    },
    getDeletaAllRelateMatter () {
      var url = _API_ + 'api/article/editor/flagRelationMaterial'
      var option = {
        ...this.$store.getters.baseOption,
        params: {
          articleId: this.$parent.$parent.articleId,
          "flag": false
        }
      }
      api._post(url, option).then((res) => {
        if (res.code == 200) {
          console.log('删除完了')
          this.$root.eventHub.$emit('setRelateMatterFlag', this.$parent.$parent.articleId, false)
          var objMatter = JSON.parse(JSON.stringify(this.articleMspObj))
          this.$set(objMatter, 'flag_material', false)
          if (this.$route.path === "/editorArticle" || this.$route.path === "/atlasmanuscript") {
            try {
              window.opener.postMessage(objMatter, '*')
            } catch (error) {
              console.log(error)
            }
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    changeMatterBaseInfo (data) {
      this.$root.eventHub.$emit('singleModifyInfoModel', data, data.type)
    },
    batchChangeRelateMatter () {
      this.$root.eventHub.$emit('batchModifyInfoModel', this.currentMaterial, this.currentMaterial[0].type)
    },
    batchDownLoadPicture () {
      var urls = []
      for (var i = 0; i < this.currentMaterial.length; i++) {
        if (this.currentMaterial[i].isChoice) {
          urls.push({ url: this.currentMaterial[i].origin_url, name: this.currentMaterial[i].title })
        }
      }
      var option = {
        ...this.$store.getters.baseOption,
        'params': {
          'urls': urls,
          'title': this.articleMspObj.title,
          'caller': 1
        }
      }
      api._post(_IMGFILEURL_ + 'picture/packageDownloadV2', option).then((resp) => {
        if (resp.code === 200) {
          download(resp.data)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    deleteMoreRelateMatter () {
      var ids = []
      for (var i = 0; i < this.currentMaterial.length; i++) {
        if (this.currentMaterial[i].isChoice) {
          ids.push(this.currentMaterial[i].id)
        }
      }

      var url = _IMGFILEURL_ + 'public/delArticle_m'
      var option = {
        ...this.$store.getters.baseOption,
        params: {
          articleId: this.$parent.$parent.articleId,
          materialIds: ids
        }
      }
      this.$confirm('确认删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api._post(url, option).then((res) => {
          if (res.code == 200) {
            this.$notify.success({
              title: '成功',
              message: '删除成功'
            })
            for (var m = this.currentMaterial.length - 1; m >= 0; m--) {
              for (var j = 0; j < ids.length; j++) {
                if (this.currentMaterial[m] && this.currentMaterial[m].id) {
                  if (this.currentMaterial[m].id === ids[j]) {
                    this.currentMaterial.splice(m, 1)
                  }
                }
              }
            }
            this.allRelateMatterLength = this.allRelateMatterLength - ids.length
            if (this.allRelateMatterLength == 0) {
              this.getDeletaAllRelateMatter()
            }
            this.isCheckedAll = false
          }
        }).catch((error) => {
          console.log(error)
        })

      }).catch(() => {
        console.log('取消')
      })
    }
  },
  watch: {
    newsTopicObj () {
      if (this.newsTopicObj) {
        // this.currentMaterialType = 'picture'
        // this.currentMaterial = this.newsTopicObj.pictures
        this.getEachTypeMaterialData(this.currentMaterialType)
        this.allRelateMatterLength = this.newsTopicObj.pictures.length + this.newsTopicObj.videos.length + this.newsTopicObj.audios.length + this.newsTopicObj.files.length
      } else {
        this.currentMaterial = []
        this.allRelateMatterLength = 0
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
@import '../../../styles/newstopic.styl'

.related_matter
  height 90% !important

.upload_button
  position absolute
  bottom 16px
  display flex
  justify-content center
  width 100%

.bottom_content
  display flex
  align-items center
  padding 10px 0 0 10px

  .operate_button
    margin-left 10px
    color #688eff
    font-size 14px
    cursor pointer
</style>
